import { Button } from "@mui/material";
import styles from "./TextComponent.module.scss";
// eslint-disable-next-line import/no-cycle
import { getTextComponentStyles } from "./TextComponent.styles";

export interface TextComponentProps {
  text: string;
  fontSize: string;
  color: "primary" | "secondary";
  uppercase?: boolean;
  underline?: boolean;
  onclick?: () => void;
  disabled?: boolean;
  dark?: boolean;
}

function TextComponent(props: TextComponentProps) {
  const {
    text,
    fontSize,
    underline,
    color,
    uppercase,
    disabled,
    onclick,
    dark,
  } = props;

  const TextComponentStyles = getTextComponentStyles(
    color,
    underline,
    uppercase,
    dark
  );
  return (
    <Button
      disableRipple
      className={`${styles.textComponent}`}
      sx={TextComponentStyles}
      disabled={disabled}
      onClick={onclick}
    >
      <p className={`${fontSize} ${styles.textComponentLabel}`}>{text}</p>
    </Button>
  );
}

export default TextComponent;
